export function resetCSS(ignoreClass) {
    document
        .querySelectorAll(`link[href*=".css"]:not(${ignoreClass})`)
        .forEach((link) => link.remove());
}
